<template>
  <div class="app-container">
    <div class="netdisc-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="netdisc-list-filter-label">文件名</label>
            <el-input class="netdisc-list-filter-value" placeholder="文件名" @keyup.enter.native="search" v-model.trim="keyword" clearable size="small"></el-input>
          </div>
        </el-col>
        <div>
          <el-button class="netdisc-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
          <el-button class="netdisc-list-filter-search" size="small" @click="search">立即筛选</el-button>
        </div>
      </el-row>
    </div>
    <basic-container>
      <!-- 顶部按钮区 -->
      <div class="operation-group">
        <el-upload class="upload-wrapper" :http-request="handleHttpRequest" :show-file-list="false" :before-upload="beforeUpload">
          <el-button class="btn-upload" type="primary" title="上传" size="medium">
            <i class="el-icon-upload"></i>&nbsp;上传
          </el-button>
        </el-upload>
        <el-button class="remove-hover" type="primary" title="新建文件夹" size="medium" @click="clickNewDirBtn" plain>
          <i class="el-icon-circle-plus-outline"></i>&nbsp;新建文件夹
        </el-button>
        <el-button class="remove-hover" type="primary" title="拖拽排序" size="medium" @click="clickSortBtn" :disabled="fileList.length === 0" plain>
          <i class="el-icon-sort"></i>&nbsp;{{drag.startDrag ? '关闭' : '开启'}}拖拽排序
        </el-button>
        <!-- 选中文件后显示的按钮区域 -->
        <div class="more-operation" v-show="haveSelectedCheckbox()">
          <el-button class="remove-hover" type="primary" title="删除" size="medium" @click="clickDeleteBtn" plain>
            <i class="el-icon-delete"></i>&nbsp;删除
          </el-button>
          <el-button class="remove-hover" type="primary" title="重命名" size="medium" @click="clickRenameBtn" :disabled="renameBtnStatus" plain>
            <i class="el-icon-edit-outline"></i>&nbsp;重命名
          </el-button>
          <el-button type="primary" title="移动到" size="medium" class="remove-hover" @click="clickMoveBtn" :disabled="moveBtnStatus" plain>
            <i class="el-icon-sort" style="transform: rotate(270deg)"></i>&nbsp;移动到
          </el-button>
        </div>
      </div>
      <!-- 文件列表区 -->
      <div class="file-list-area">
        <!-- 面包屑导航-->
        <div class="file-list-area-header">
          <span v-if="nav.dirBreadcrumb.length === 1">全部文件</span>
          <template v-else>
            <ul>
              <li>
                <span class="dir" @click="getFileListByOperation(2)">返回上一级</span>
                <span>&nbsp;|&nbsp;</span>
              </li>
              <li v-for="(dir, index) in nav.dirBreadcrumb" :key="index">
                <template v-if="index !== nav.dirBreadcrumb.length - 1">
                  <span class="dir" @click="getFileListByOperation(3, index)" :title="dir.name">
                    {{dir.name.length > 10 ? dir.name.substr(0, 10) + '...' : dir.name}}
                  </span>
                  <i class="el-icon-arrow-right"></i>
                </template>
                <span v-else :title="dir.name">
                  {{dir.name.length > 10 ? dir.name.substr(0, 10) + '...' : dir.name}}
                </span>
              </li>
            </ul>
          </template>
        </div>
        <!-- 全选按钮 列表表头 已选择n个文件 -->
        <div class="file-list-area-th">
          <div class="file-list-area-th-name">
            <el-checkbox :disabled="checkbox.selectAllDisabled" v-model="checkbox.selectAll" @change="selectAllCheckboxChange"></el-checkbox>
            <template v-if="!haveSelectedCheckbox()">
              <span class="text">文件名</span>
              <span class="space"></span>
            </template>
            <span v-else class="text">已选择{{ checkedFileCount }}个文件</span>
          </div>
          <div class="file-list-area-th-uploader text">上传者</div>
          <div class="file-list-area-th-size text">大小</div>
          <div class="file-list-area-th-update-time text">修改日期</div>
        </div>
        <!-- 文件列表区域 -->
        <div class="file-list-area-body" v-loading="getListLoading">
          <ul v-if="showFileList">
            <!-- 新建文件夹输入框 -->
            <li v-if="dir.isClickNewDirBtn">
              <div class="column">
                <el-checkbox disabled></el-checkbox>
                <img class="file-type-icon" src="../../static/images/file/file_folder.svg"/>
                <el-input @keyup.enter.native="createDir" ref="dir" clearable v-focus style="width: 150px" size="mini" placeholder="请输入文件夹名称" v-model="dir.newDirName"></el-input>
                &nbsp;
                <el-button icon="el-icon-check" size="mini" @click="createDir"></el-button>
                <el-button icon="el-icon-close" size="mini" @click="cancelCreateDir"></el-button>
              </div>
              <div class="column">-</div>
              <div class="column">-</div>
              <div class="column">-</div>
              <div class="column">-</div>
            </li>
            <!-- 可拖拽列表区 -->
            <draggable v-model="fileList" :disabled="!drag.startDrag" animation="200" @end="handleDragEnd" :move="handleDragMove">
                <transition-group>
                  <li v-for="(file, index) in fileList" :key="file.id" :class="[file.isDir ? 'dir' : 'file', {'drag-item' : drag.startDrag, 'drag-item-first' : drag.startDrag && index === 0}]">
                    <div class="column">
                      <el-checkbox v-model="file.checked" @change="generalCheckboxChange" :disabled="file.disabled"></el-checkbox>
                      <img v-if="file.isDir" class="file-type-icon" src="../../static/images/file/file_folder.svg"/>
                      <img v-else class="file-type-icon" :src="getFileType(file.name).src"/>
                      <span v-if="!file.rename" class="file-list-item" @click="file.isDir ? getFileListByOperation(1, file) : previewFile(file) " >{{ file.name }}</span>
                      <el-input @keyup.enter.native="renameFile(file)" v-show="file.rename" :clearable="file.isDir" :ref="'input-rename-' + file.id" style="width: 150px" size="mini" v-model="file.newName"></el-input>
                      &nbsp;
                      <el-button v-show="file.rename" icon="el-icon-check" size="mini" @click="renameFile(file)"></el-button>
                      <el-button v-show="file.rename" icon="el-icon-close" size="mini" @click="cancelRenameFile(file)"></el-button>
                    </div>
                    <div class="column">{{ file.updatedByName }}</div>
                    <div class="column">{{ file.isDir ? "-" : formatFileSize(file.size) }}</div>
                    <div class="column">{{ file.updatedTime }}</div>
                  </li>
                </transition-group>
            </draggable>
          </ul>
          <div class="no-files" v-else>
            <img src="../../static/images/file/no-file.png">
            <span style="display: block;">暂时没有文件或文件夹</span>
          </div>
        </div>
        <div class="file-list-area-pagination">
          <el-pagination v-if="page.show" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.current"
          :page-sizes="[10, 50, 200, 500]" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
          </el-pagination>
        </div>
      </div>
      <!-- 文件上传右下角Dialog -->
      <div class="upload-dialog" v-show="up.showDialog">
        <div class="upload-dialog-header">
          <div class="upload-status" @click="toggleDialogBodyShow">
            {{ up.uploadTip }}
          </div>
          <img v-if="!up.showDialogBody" class="dialog-header-icon dialog-max" src="../../static/images/file/dialog-max.png" @click="toggleDialogBodyShow"/>
          <img v-else width="14" class="dialog-header-icon dialog-min" src="../../static/images/file/dialog-min.png" @click="toggleDialogBodyShow"/>
          <img class="dialog-header-icon dialog-close" src="../../static/images/file/dialog-close.png" @click="up.showDialog = false"/>
        </div>
        <div class="upload-dialog-body-common upload-dialog-body-header">
          <div class="filename">文件名</div>
          <div class="size">大小</div>
          <div class="dir">上传目录</div>
          <div class="status">状态</div>
        </div>
        <div :class="['upload-dialog-body', { 'hide-upload-dialog-body': !up.showDialogBody }]">
          <div class="upload-dialog-body-body-wrapper" v-for="(file, index) in uploadFileList" :key="index">
            <div class="upload-dialog-body-common upload-dialog-body-item">
              <div class="filename" :title="file.name">{{ file.name }}</div>
              <div class="size">{{ formatFileSize(file.size) }}</div>
              <div class="dir">{{ file.dir }}</div>
              <div class="status">
                {{ file.status }}
                <img class="file-reupload" v-show="file.reupload" @click="reupload(file)" src="../../static/images/file/file-reupload.png"/>
              </div>
            </div>
            <div class="upload-dialog-body-item-progress" v-show="!file.over" :style="{ width: file.percentage + '%' }"></div>
          </div>
        </div>
      </div>
      <!-- 预览文件dialog -->
      <el-dialog class="preview-img-dialog" width="30%" :title="preview.fileName" :visible="preview.showImgDialog" :before-close="handlePreviewImgDialogClose">
        <img :src="preview.imgSrc" style="width: 100%" />
      </el-dialog>
      <el-dialog class="preview-other-dialog" top="5vh" width="90%" :title="preview.fileName" :visible="preview.showOtherDialog" :before-close="handlePreviewOtherDialogClose">
        <iframe :src="preview.otherFileSrc" frameborder="0" scrolling="no" style="width: 100%; height: 100%"></iframe>
      </el-dialog>
      <!-- 移动到Dialog -->
      <el-dialog top="28vh" title="移动到" :visible.sync="move.showDialog" @close="handleMoveDialogClose" class="move-dialog">
        <el-tree v-if="move.showTree" ref="dirTree" node-key="id" :props="dirTreeProps" :load="loadNode" :default-expanded-keys="[-1]" :check-strictly="true" @check-change="handleCheckChange" lazy show-checkbox>
          <span class="dir-tree-item" slot-scope="{ node }">
            <img class="dir-icon" src="../../static/images/file/file_folder.svg"/>
            <span>{{node.label}}</span>
          </span>
        </el-tree>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="moveFiles">确定</el-button>
          <el-button @click="move.showDialog = false">取消</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>

import draggable from 'vuedraggable'
import { saveAs } from 'file-saver'
import { dateFormat } from '@/util/date';
import { imageBase64ToUint8Array } from '@/util/util'
import { uploadErrorType, uploadStatus, fileType, fileTypeList } from '@/const/crud/netdisc/netdisc';
import { getOSSResourceUrl, getFileList, addFile, updateFile, deleteFile, moveFiles, sortFileByDrag } from '@/api/netdisc/netdisc';
import { getOSSSign, getFileNameUUID, getOSSFileNetdisc, uploadOSSFileWithProgress } from '@/api/basic/aliyunoss';

export default {
  name: 'netdisc',
  components: {
    draggable
  },
  data() {
    return {
      dirTreeProps: {
        label: 'name'
      },
      // 存放各种文件类型的图标
      fileTypeList: fileTypeList,
      // 上传的文件列表
      uploadFileList: [],
      // 控制加载文件动画显示
      getListLoading: false,
      // 导航栏参数
      nav: {
        dirBreadcrumb: [{
          id: -1,
          name: '全部文件'
        }],
        parentDirIndex: -1
      },
      // 列表查询参数
      page: {
        show: false,
        current: 1,
        size: 10,
        total: 0
      },
      keyword: '',
      // 延时搜索请求
      sendSearchRequestTimer: null,
      // 当前所在目录信息
      currentDir: {
        id: -1,
        name: '全部文件'
      },
      // 是否显示文件列表
      showFileList: true,
      // 文件和文件夹统一命名为file，通过is_dir来区分
      fileList: [],
      // 上传dialog
      up: {
        showDialog: false,
        showDialogBody: false,
        uploadTip: '上传中',
      },
      checkbox: {
        selectAllDisabled: false,
        // 控制全选按钮是否勾选
        selectAll: false,
        // 只要有一个file被选中，就展示'更多操作'区域的按钮
        haveSelect: false,
      },
      dir: {
        newDirName: '',
        isClickNewDirBtn: false,
      },
      // 图片预览需要自适应宽高的dialog，不同于其他文件的预览
      preview: {
        fileName: '',
        showImgDialog: false,
        showOtherDialog: false,
        imgSrc: '',
        otherFileSrc: '',
      },
      move: {
        showDialog: false,
        targetId: null,
        // 强制每次打开dialog刷新目录树
        showTree: false
      },
      drag: {
        startDrag: false,
        // 请求锁，控制用户两次拖拽之间的时间间隔
        lock: false,
        interval: 300
      }
    };
  },
  created: function () {
    this.fileTypeList.forEach((fileType) => {
      fileType.src = require('../../static/images/file/file_' + fileType.type + '.svg');
    });
  },
  mounted: function () {
    // 加载初始列表数据
    this.baseGetFileList();
  },
  computed: {
    // 控制重命名按钮是否禁用（某一时刻勾选一项，重命名按钮才放开）
    renameBtnStatus() {
      return this.fileList.filter((file) => file.checked).length !== 1;
    },
    // 控制重命名按钮是否禁用（系统暂时不支持移动文件夹，如果勾选文件夹，移动到按钮被禁用）
    moveBtnStatus () {
      return this.fileList.some(file => file.checked && file.isDir);
    },
    // 获取勾选项的数量
    checkedFileCount() {
      let count = 0;
      this.fileList.forEach((file) => {
        if (file.checked) {
          count++;
        }
      });
      return count;
    },
  },
  methods: {
    async handleDragEnd (e) {
      if (e.oldIndex === e.newIndex) {
        return;
      }
      if (this.drag.lock) {
        return;
      }
      this.drag.lock = true;
      const flag = e.oldIndex > e.newIndex;
      const startIndex = flag ? e.newIndex : e.oldIndex;
      const endIndex = !flag ? e.newIndex : e.oldIndex;
      // 获取拖拽结束后，新的顺序下的对象数组
      const range = this.fileList.slice(startIndex, endIndex + 1);
      const ids = range.map(file => file.id);
      // 组合出未移动前的对象数组
      const rangOrigin = flag ? range.slice(1).concat(range[0]) :
        [range[range.length - 1]].concat(range.slice(0, range.length - 1));
      // 拿到未移动前对象的sort值数组
      const sorts = rangOrigin.map(file => file.sort);
      // 构建请求数据，包含id和最新的sort值
      const data = [];
      for (let index = 0; index < ids.length; index++) {
        const id = ids[index];
        const sort = sorts[index];
        data.push({
          id,
          sort
        });
        this.fileList[startIndex + index].sort = sort;
      }
      try {
        const response = await sortFileByDrag(data);
        this.$message({
          type: 'success',
          message: '操作成功'
        })
      } finally {
        setTimeout(() => {
          this.drag.lock = false;
        }, this.drag.interval)
      }
    },
    handleDragMove (e, originEvent) {
      // 文件和文件夹相隔离，不能拖到各自的区域
      return e.draggedContext.element.isDir === e.relatedContext.element.isDir && !this.drag.lock;
    },
    clickSortBtn () {
      this.drag.startDrag = !this.drag.startDrag;
    },
    // 切换目录时需要重置某些设置
    resetSetting (dir) {
      this.page.current = 1;
      this.keyword = '';
      clearTimeout(this.sendSearchRequestTimer);
    },
    recoverSetting(dir) {
      this.page.current = dir.current;
      this.page.size = dir.size;
      this.keyword = dir.keyword;
    },
    searchReset() {
      this.keyword = '';
      this.search();
    },
    search () {
      // 延时搜索，两次输入间隔超过700ms才call api
      clearTimeout(this.sendSearchRequestTimer);
      this.sendSearchRequestTimer = setTimeout(() => {
        this.page.current = 1;
        this.baseGetFileList();
      }, 700)
    },
    handleSizeChange (val) {
      this.page.size = val;
      this.page.current = 1;
      this.baseGetFileList();
    },
    handleCurrentChange (val) {
      this.page.current = val;
      this.baseGetFileList();
    },
    async baseGetFileList() {
      this.getListLoading = true;
      this.page.show = false;
      let response;
      try {
        response = await getFileList({
          current: this.page.current,
          size: this.page.size,
          name: this.keyword,
          parentId: this.currentDir.id
        });
        const fileList = response.data.data.records;
        // 添加额外属性
        fileList.forEach((file) => {
          file.newName = file.name;
          file.rename = false;
          file.checked = false;
          file.disabled = false;
        });
        this.fileList = fileList;
        const empty = fileList.length === 0;
        this.showFileList = !empty;
        this.checkbox.selectAllDisabled = empty;
        this.page.total = response.data.data.total;
        this.page.current = response.data.data.current;
        this.page.size = response.data.data.size;
        this.page.show = true;
      } finally {
        this.getListLoading = false;
      }
    },
    getFileListByOperation(operation, param) {
      this.unselectAllCheckbox();
      this.dir.isClickNewDirBtn = false;
      let dir;
      switch (operation) {
        // 获取子目录文件
        case 1:
          dir = param;
          const currentDirIndex = this.nav.dirBreadcrumb.length - 1;
          this.nav.dirBreadcrumb[currentDirIndex].current = this.page.current;
          this.nav.dirBreadcrumb[currentDirIndex].size = this.page.size;
          this.nav.dirBreadcrumb[currentDirIndex].keyword = this.keyword;
          this.nav.dirBreadcrumb.push({
            id: dir.id,
            name: dir.name
          });
          this.nav.parentDirIndex++;
          this.resetSetting(dir);
          break;
        // 返回上层目录
        case 2:
          dir = this.nav.dirBreadcrumb[
            this.nav.parentDirIndex--
          ];
          this.nav.dirBreadcrumb.pop();
          this.recoverSetting(dir);
          break;
        // 点击面包屑导航中的某一个目录
        case 3:
          const index = param;
          dir = this.nav.dirBreadcrumb[index];
          this.nav.dirBreadcrumb = this.nav.dirBreadcrumb.slice(0, index + 1);
          this.nav.parentDirIndex = index - 1;
          this.recoverSetting(dir);
          break;
        default:
          break;
      }
      // 修改当前所在目录信息
      this.currentDir.id = dir.id;
      this.currentDir.name = dir.name;
      this.baseGetFileList();
    },
    handlePreviewImgDialogClose() {
      this.preview.imgSrc = '';
      this.preview.fileName = '';
      this.preview.showImgDialog = false;
    },
    handlePreviewOtherDialogClose() {
      this.preview.fileName = '';
      this.preview.otherFileSrc = '';
      this.preview.showOtherDialog = false;
    },
    async previewFile(file) {
      const response = await getOSSResourceUrl(file.id);
      if (!response || response.status !== 200) {
        return;
      }
      const src = response.data.data
      this.preview.fileName = file.name;
      switch (file.type) {
        case fileType.PICTURE:
          this.preview.showImgDialog = true;
          this.preview.imgSrc = src;
          break;
        case fileType.VIDEO:
        case fileType.PDF:
          this.preview.showOtherDialog = true;
          this.preview.otherFileSrc = src;
          break;
        default:
          this.$message({
            type: 'warning',
            message: '暂不支持此种文件的预览，已自动为您下载',
          });
          const FileSaver = require('file-saver');
          FileSaver.saveAs(src, file.name);
          break;
      }
    },
    // 添加项到右下角上传dialog中
    addUploadFileListItem(rawFile) {
      const { name, size } = rawFile;
      const key = new Date().getTime();
      const uploadItem = {
        // 唯一标识这个item
        key: key,
        name: name,
        size: size,
        dir: this.currentDir.name,
        percentage: 0,
        // 是否结束了上传这个动作
        over: false,
        // 是否成功上传到oss并且数据库保存成功
        success: false,
        // 状态描述信息
        status: '0%',
        // 重传的文件
        rawFile: rawFile,
        // 是否需要重传
        reupload: false,
        // 错误类型
        // 1: 上传到oss时出错，2: 保存文件信息到admin后台出错
        errorType: null,
      };
      this.uploadFileList.push(uploadItem);
      return uploadItem;
    },
    // 处理上传错误
    handleUploadError(uploadItem, errorType) {
      uploadItem.success = false;
      uploadItem.reupload = true;
      uploadItem.errorType = errorType;
      uploadItem.status = uploadStatus.FAILED;
    },
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    async generatorVideoCoverImage(videoFile) {
      return new Promise((resolve, reject) => {
        let videoElement = document.createElement('video');
        const blob = new Blob([videoFile], {type: videoFile.type.toLowerCase()});
        const videoUrl = this.getObjectURL(blob);
        videoElement.setAttribute('x-webkit-airplay', '');
        videoElement.setAttribute('webkit-playsinline', '');
        videoElement.setAttribute('x5-playsinline', '');
        videoElement.setAttribute('playsinline', '');
        videoElement.setAttribute('x-webkit-airplay', '');
        videoElement.setAttribute('src', videoUrl);
        videoElement.muted = true;

        videoElement.addEventListener('loadeddata', async () => {
            const canvas = document.createElement('canvas');
            canvas.width = videoElement.videoWidth;
            canvas.height = videoElement.videoHeight;
            canvas
              .getContext('2d')
              .drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            videoElement.setAttribute('src', null);
            window.URL.revokeObjectURL(videoUrl);
            videoElement = null;

            const b64Image = canvas.toDataURL('image/jpeg', 0.4);
            const u8Image = imageBase64ToUint8Array(b64Image);
            const key = `${getOSSFileNetdisc() + getFileNameUUID()}.jpg`;
            const file = new Blob([u8Image], { type: 'image/jpg' });
            resolve({
              file,
              key,
            });
          }, { once: true }
        );

        videoElement.load();
        videoElement.play();
      });
    },
    // 保存文件信息到数据库
    async addFileInfo(uploadItem) {
      let response;
      try {
        response = await addFile({
          parentId: this.currentDir.id,
          name: uploadItem.name,
          size: uploadItem.size,
          isDir: false,
          type: uploadItem.type,
          objectKey: uploadItem.formData.get('key'),
          updatedTime: dateFormat(new Date()),
        });
        const file = response.data.data;
        // 成功上传，修改状态
        uploadItem.success = true;
        uploadItem.status = uploadStatus.SUCCESS;
        // 新上传的文件插入到最后一个文件夹的后面
        const insertIndex = this.fileList.filter(file => file.isDir).length;
        // 向fileList中增加一项
        this.fileList.splice(insertIndex, 0, {
          checked: false,
          // contentUrl: file.contentUrl,
          id: file.id,
          isDir: file.isDir,
          name: file.name,
          newName: file.name,
          parentId: file.parentId,
          rename: false,
          size: file.size,
          type: file.type,
          updatedTime: file.updatedTime,
          sort: file.sort
        });
        this.showFileList = true;
        this.page.total++;
      } catch (error) {
        this.handleUploadError(uploadItem, uploadErrorType.ADMIN_ERROR);
      } finally {
        uploadItem.over = true;
        this.updateDialogTip();
      }
    },
    async uploadToOss(uploadItem) {
      // 更新上传进度
      const onUploadProgress = (progressEvent) => {
        uploadItem.percentage = Number(
          ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2)
        );
        uploadItem.status = `${uploadItem.percentage}%`;
      };
      // const cdnHost = uploadItem.cdnHost;
      const host = uploadItem.host;
      const formData = uploadItem.formData;
      // 视频文件需要首先上传封面到oss
      // const originKey = formData.get('key');
      // const originFile = formData.get('file');
      const type = this.getFileType(uploadItem.name).value;
      uploadItem.type = type;
      // const thumbnailProcessing = '?x-oss-process=image/quality,Q_30';
      // if (type === fileType.VIDEO) {
      //   // 生成封面
      //   const coverImage = await this.generatorVideoCoverImage(originFile);

      //   formData.set('key', coverImage.key);
      //   formData.set('file', coverImage.file);

      //   response = await uploadOSSFile(host, formData);

      //   uploadItem.coverUrl = `${cdnHost}/${coverImage.key}${thumbnailProcessing}`;

      //   formData.set('key', originKey);
      //   formData.set('file', originFile);
      // } else if (type === fileType.PICTURE) {
      //   uploadItem.coverUrl = `${uploadItem.contentUrl}${thumbnailProcessing}`;
      // }
      let response;
      try {
        response = await uploadOSSFileWithProgress(host, formData, onUploadProgress, true);
        this.addFileInfo(uploadItem);
      } catch (error) {
        this.handleUploadError(uploadItem, uploadErrorType.OSS_ERROR);
      }
    },
    async getSign(uploadItem) {
      const rawFile = uploadItem.rawFile;
      const fileKey = getOSSFileNetdisc() + getFileNameUUID() + rawFile.name;
      let response;
      try {
        response = await getOSSSign();
        const cdnHost = response.data.data.cdnHost;
        const host = response.data.data.host;

        const formData = new FormData();
        formData.append('key', fileKey);
        formData.append('policy', response.data.data.policy);
        formData.append('OSSAccessKeyId', response.data.data.accessKeyId);
        formData.append('success_action_status', 200);
        formData.append('signature', response.data.data.signature);
        formData.append('file', rawFile);

        // uploadItem.contentUrl = cdnHost + '/' + fileKey;
        uploadItem.host = host;
        uploadItem.cdnHost = cdnHost;
        uploadItem.formData = formData;
        uploadItem.cdnHost = cdnHost;

        this.uploadToOss(uploadItem);
      } catch (error) {
        this.handleUploadError(uploadItem, uploadErrorType.GET_SIGN_ERROR);
      } finally {
        uploadItem.over = true;
        this.updateDialogTip();
        this.getListLoading = false;
      }
    },
    upload(uploadItem) {
      if (uploadItem.errorType === null) {
        this.getSign(uploadItem);
      } else {
        switch (uploadItem.errorType) {
          case uploadErrorType.GET_SIGN_ERROR:
            this.getSign(uploadItem);
            break;
          case uploadErrorType.OSS_ERROR:
            this.uploadToOss(uploadItem);
            break;
          case uploadErrorType.ADMIN_ERROR:
            this.addFileInfo(uploadItem);
            break;
        }
        uploadItem.errorType = null;
      }
    },
    reupload(uploadItem) {
      uploadItem.over = false;
      uploadItem.percentage = 0;
      uploadItem.success = false;
      uploadItem.reupload = false;
      uploadItem.status = '0%';
      this.upload(uploadItem);
    },
    handleHttpRequest(data) {
      const rawFile = data.file;
      const uploadItem = this.addUploadFileListItem(rawFile);
      this.updateDialogTip();
      this.upload(uploadItem);
    },
    updateDialogTip() {
      // 扫描uploadFileList， 获取上传的文件总数，已完成的文件总数
      let totalCount = this.uploadFileList.length;
      let uploadSuccessFileCount = 0;
      for (const uploadItem of this.uploadFileList) {
        if (uploadItem.success) {
          uploadSuccessFileCount++;
        }
      }
      this.up.uploadTip = `${uploadStatus.UPLOADING} (${uploadSuccessFileCount}/${totalCount})`;
      if (totalCount === uploadSuccessFileCount) {
        this.up.uploadTip = uploadStatus.COMPLETED;
      }
    },
    formatFileSize(value) {
      if (null == value || value == '') {
        return '0 B';
      }
      const unitArr = new Array('B', 'KB', 'MB', 'GB');
      let index = 0;
      const srcsize = parseFloat(value);
      index = Math.floor(Math.log(srcsize) / Math.log(1024));
      let size = srcsize / Math.pow(1024, index);
      size = size.toFixed(0);
      return size + ' ' + unitArr[index];
    },
    getFileType(name) {
      const extension = name.substr(name.lastIndexOf('.') + 1).toLowerCase();
      for (const fileType of this.fileTypeList) {
        const extensions = fileType.extensions;
        const index = extensions.indexOf(extension);
        if (index !== -1) {
          return fileType;
        }
      }
      return this.fileTypeList.find((fileType) => fileType.type === 'other');
    },
    toggleDialogBodyShow() {
      this.up.showDialogBody = !this.up.showDialogBody;
    },
    beforeUpload(file) {
      if ('forbidden' === this.getFileType(file.name).type) {
        this.$message({
          type: 'info',
          message: '系统暂时不支持此种文件上传',
          duration: 8000
        })
        return false;
      }
      if (file.name.substr(0, file.name.lastIndexOf('.')).length > 45) {
        this.$message({
          type: 'info',
          message: '名称过长，不能超过45个字符'
        })
        return false;
      }
      this.up.showDialog = true;
      this.up.showDialogBody = true;
    },
    clickNewDirBtn() {
      this.dir.newDirName = '';
      this.fileList.forEach((file) => (file.checked = false));
      this.checkbox.selectAll = false;
      this.dir.isClickNewDirBtn = true;
      this.showFileList = true;
      this.fileList.forEach(file => file.disabled = true);
      this.checkbox.selectAllDisabled = true;
    },
    cancelCreateDir() {
      this.dir.isClickNewDirBtn = false;
      this.showFileList = this.fileList.length !== 0;
      this.fileList.forEach(file => file.disabled = false);
      this.checkbox.selectAllDisabled = false;
    },
    async createDir() {
      const newDirName = this.dir.newDirName;
      if (newDirName === null || newDirName.trim() === '') {
        this.$message({
          type: 'error',
          message: '名称不能为空'
        })
        return;
      }
      if (newDirName.length > 45) {
        this.$message({
          type: 'info',
          message: '名称过长，不能超过45个字符'
        })
        return;
      }
      this.getListLoading = true;
      let response;
      try {
        response = await addFile({
          parentId: this.currentDir.id,
          name: this.dir.newDirName,
          isDir: true,
          updatedTime: dateFormat(new Date()),
        });
        const file = response.data.data;
        // 隐藏新建文件夹框
        // 向fileList中增加一项
        this.fileList.unshift({
          checked: false,
          // contentUrl: file.contentUrl,
          // coverUrl: file.coverUrl,
          id: file.id,
          isDir: file.isDir,
          name: file.name,
          newName: file.name,
          parentId: file.parentId,
          rename: false,
          size: file.size,
          type: file.type,
          updatedTime: file.updatedTime,
          sort: file.sort
        });
        this.dir.isClickNewDirBtn = false;
        this.checkbox.selectAllDisabled = false;
        this.fileList.forEach(file => file.disabled = false);
        this.page.total++;
        this.$message({
          type: 'success',
          message: '创建文件夹成功!',
        });
        this.baseGetFileList();
      } catch (error) {
      } finally {
        this.getListLoading = false;
      }
    },
    clickRenameBtn() {
      // 找到被选中的唯一file
      const file = this.fileList.find((file) => file.checked);
      file.newName = file.name;
      file.rename = true;
      this.fileList.forEach(file => file.disabled = true);
      this.checkbox.selectAllDisabled = true;
      // 获取到el-input中的原生input对象
      const input = this.$refs[`input-rename-${file.id}`][0].$el.querySelector('.el-input__inner');
      setTimeout(() => {
        input.focus();
        input.setSelectionRange(0, file.name.lastIndexOf('.'));
      }, 30);
    },
    cancelRenameFile(file) {
      file.rename = false;
      file.checked = false;
      this.fileList.forEach(file => file.disabled = false);
      this.checkbox.selectAllDisabled = false;
    },
    async renameFile(file) {
      const oldName = file.name;
      const newName = file.newName;
      if (newName === null || newName.trim() === '') {
        this.$message({
          type: 'error',
          message: '名称不能为空'
        })
        return;
      }
      if (oldName === newName) {
        this.$message({
          type: 'warning',
          message: '新旧文件名不能相同'
        })
        return;
      }
      if (newName.substr(0, newName.lastIndexOf('.')).length > 45) {
        this.$message({
          type: 'info',
          message: '名称过长，不能超过45个字符'
        })
        return;
      }
      const oldExtension = oldName.substr(file.name.lastIndexOf('.') + 1);
      const newExtension = newName.substr(newName.lastIndexOf('.') + 1);
      if (!file.isDir && oldExtension !== newExtension) {
        this.$message({
          type: 'warning',
          message: `不允许修改文件后缀名[.${oldExtension}]`
        })
        return;
      }
      this.getListLoading = true;
      const updatedTime = dateFormat(new Date());
      let response;
      try {
        response = await updateFile({
          id: file.id,
          name: file.newName,
          updatedTime: updatedTime,
        });
        file.name = file.newName;
        file.updatedTime = updatedTime;
        file.checked = false;
        this.cancelRenameFile(file);
        this.$message({
          type: 'success',
          message: '重命名成功!',
        });
        this.checkbox.selectAll = false;
      } catch (error) {
      } finally {
        this.getListLoading = false;
      }
    },
    clickDeleteBtn() {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const ids = this.fileList.filter(file => file.checked).map((file) => file.id);
        let response;
        try {
          response = await deleteFile(ids.join(','));
          this.checkbox.selectAll = false;
          this.baseGetFileList();
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        } catch (error) {
          this.$message({
            type: 'error',
            message: '删除失败!',
          });
        }
      });
    },
    selectAllCheckboxChange(select) {
      this.fileList.forEach((file) => (file.checked = select));
    },
    generalCheckboxChange(select) {
      // 更新全选按钮的状态
      this.checkbox.selectAll = this.fileList.every((file) => file.checked);
    },
    haveSelectedCheckbox() {
      return this.fileList.some((file) => file.checked);
    },
    unselectAllCheckbox() {
      this.fileList.forEach((file) => {
        file.checked = false;
      });
      this.checkbox.selectAll = false;
    },
    handleMoveDialogClose () {
      this.move.showTree = false;
    },
    clickMoveBtn () {
      const isMoveDir = this.fileList.some(file => file.checked && file.isDir);
      if (isMoveDir) {
        this.$message({
          type: 'warning',
          message: '系统暂时不支持移动文件夹'
        });
        return;
      } else {
        this.move.showDialog = true;
        this.move.showTree = true;
      }
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve([{id: -1, name: '全部文件'}]);
      } else {
        setTimeout(async () => {
          const response = await getFileList({
            isDir: true,
            parentId: node.key
          });
          return resolve(response.data.data.records);
        }, 500);
      }
    },
    handleCheckChange (data, checked, child) {
      if (checked) {
        this.$refs.dirTree.setCheckedKeys([data.id]);
        this.move.targetId = data.id;
      } else {
        if (this.move.targetId === data.id) {
          this.move.targetId = null;
        }
      }
    },
    async moveFiles () {
      const targetId = this.move.targetId;
      if (targetId === null) {
        this.$message({
          type: 'warning',
          message: '请选择要移动到的目录'
        })
        return;
      }
      if (targetId === this.currentDir.id) {
        this.$message({
          type: 'warning',
          message: '文件已在该目录下'
        })
        return;
      }
      const response = await moveFiles({
        targetId: targetId,
        sourceIds: this.fileList.filter(file => file.checked).map(file => file.id)
      })
      this.$message({
        type: 'success',
        message: '移动成功'
      });
      this.baseGetFileList();
      this.move.showDialog = false;
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').focus();
      },
    },
  }
};
</script>

<style lang='scss' scoped>
.netdisc-list-filter {
  margin: 0px 10px;
  background-color: #fff;
  padding-top: 20px;
  padding-left: 22px;
  &-label {
    font-size: 14px;
    color: #606266;
    margin-right: 10px;
  }
  &-value {
    width: calc(100% - 90px) !important;
  }
  &-reset {
    margin-right: 8px;
  }
  &-search {
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
  .el-button+ .el-button {
    margin: 0px;
  }
}

.remove-hover:hover,
.remove-hover:focus {
  color: #5383f3;
  background: #ecf5ff;
  border-color: #b3d8ff;
}
.btn-upload {
  background-color: #5383f3;
  border-color: #5383f3;
}
.more-operation {
  display: inline-block;
  position: relative;
  top: 0;
  margin-left: 10px;
  .el-button + .el-button {
    margin-left: 0;
  }
  .el-button:nth-child(2) {
    border-left: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .el-button:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .el-button:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
/deep/ .el-checkbox .is-focus .el-checkbox__inner {
  border-color: #dcdfe6;
}
.preview-img-dialog,
.preview-other-dialog {
  /deep/ .el-dialog {
    .el-dialog__body {
      padding-top: 0;
    }
    .el-dialog__title {
      color: #424e67;
      font-size: 16px;
    }
  }
}
.preview-other-dialog {
  /deep/ .el-dialog {
    height: 90%;
    .el-dialog__body {
      height: 90%;
      padding-top: 0;
    }
  }
}
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.upload-wrapper {
  display: inline-block;
  margin-right: 10px;
}
.input-search {
  width: 260px;
  float: right;
  /deep/ .el-input__inner {
    border-radius: 33px;
    background-color: #f1f2f4;
    border: none;
  }
}
.app-container {
  /deep/ .el-card.is-always-shadow,
  /deep/ .el-card__body {
    height: 100%;
  }
}
.avue-view,
.basic-container {
  height: 100%;
}
.avue-view {
  padding-bottom: 0;
}
.basic-container .file-list-area {
  width: 100%;
  height: 74%;
  margin-top: 10px;
  &-header {
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    color: #666;
    margin-bottom: 5px;
    li {
      float: left;
    }
    .dir {
      color: #5383f3;
      cursor: pointer;
    }
    .dir:hover {
      text-decoration: underline;
    }
  }
  &-th {
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #888;
    /deep/ .el-checkbox__inner {
      margin-right: 10px;
      margin-top: 1px;
    }
    .space {
      display: inline-block;
      width: 10px;
    }
    &-name,
    &-uploader,
    &-size,
    &-update-time {
      float: left;
    }
    &-name {
      width: 54%;
    }
    &-uploader {
      width: 14%;
    }
    &-size {
      width: 15%;
    }
    &-update-time {
      width: 15%;
    }
  }
  &-body {
    position: relative;
    height: 100%;
    font-size: 12px;
    color: #424e67;
    ul {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 8px;
      }
      &::-webkit-scrollbar-track {
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        max-height: 20px;
        border-radius: 10px;
        background-color: #999;
      }
    }
    .drag-item-first {
      border-top: 1px solid #e6e6e6!important;
    }
    .drag-item {
      cursor: move;
      border-bottom: 1px solid #e6e6e6;
    }
    li:first-child {
      border-top: 1px solid transparent;
    }
    li {
      display: flex;
      align-items: center;
      height: 44px;
      border-bottom: 1px solid transparent;
      .column {
        height: 44px;
        line-height: 44px;
        margin: 2px;
        .file-list-item {
          cursor: pointer;
        }
        .file-list-item:hover {
          color: #5383f3;
        }
        img {
          cursor: default;
        }
      }
      .column:first-child {
        width: 54%;
        .dir {
          cursor: pointer;
        }
        .dir:hover {
          color: #5383f3;
        }
      }
      .column:nth-child(2) {
        width: 14%;
      }
      .column:nth-child(3) {
        width: 14%;
      }
      .columnL:last-child {
        width: 15%;
      }
    }
    .file-type-icon {
      width: 32px;
      height: 32px;
      margin: 0 10px;
      vertical-align: middle;
    }
    .no-files {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
  }
  &-pagination {
    float: right;
  }
}
.upload-dialog {
  position: fixed;
  z-index: 9999;
  bottom: 0;
  right: 20px;
  width: 550px;
  background-color: #fff;
  color: rgb(255, 255, 255);
  border: 1px solid #e2e2e2;
  box-shadow: 0 0 10px #ccc;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  &-header {
    position: relative;
    font-weight: 200;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    padding-left: 10px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background-color: #5383f3;
    .upload-status {
      cursor: text;
    }
    .dialog-header-icon {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      cursor: pointer;
    }
    .dialog-close {
      right: 10px;
    }
    .dialog-max {
      right: 36px;
    }
    .dialog-min {
      right: 36px;
    }
  }
  &-body {
    height: 249px;
    transition: all 0.3s ease-in;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      max-height: 20px;
      border-radius: 10px;
      background-color: #999;
    }
    &-common {
      display: flex;
      justify-content: space-between;
      height: 35px;
      line-height: 35px;
      font-size: 13px;
      color: #424e67;
      text-align: center;
      .filename {
        width: 242px;
        text-indent: 10px;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .size {
        flex-grow: 1;
      }
      .dir {
        flex-grow: 1;
      }
      .status {
        flex-grow: 1;
      }
    }
    &-body-wrapper {
      position: relative;
      height: 35px;
      font-size: 12px;
      .upload-dialog-body-item {
        display: flex;
        position: absolute;
        z-index: 2;
        width: 100%;
        font-size: 12px !important;
        .file-reupload {
          position: relative;
          top: 2px;
          left: 2px;
          width: 12px;
          cursor: pointer;
        }
      }
      .upload-dialog-body-item-progress {
        position: absolute;
        width: 0%;
        height: 100%;
        z-index: 1;
        transition: width 0.1s ease-in;
        background-color: #7f9eca;
      }
    }
  }
}
.move-dialog {
  .dir-tree-item {
    display: flex;
    align-items: center;
  }
  .dir-icon {
    width: 24px;
    margin-right: 12px;
  }
  /deep/ .el-tree-node__content {
    height: 32px;
  }
}

.hide-upload-dialog-body {
  margin-bottom: -284px;
}
</style>